import { render, staticRenderFns } from "./ConfigShow.vue?vue&type=template&id=d382a376&"
import script from "./ConfigShow.vue?vue&type=script&lang=js&"
export * from "./ConfigShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports